import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import classnames from 'classnames';
import ErrorAlert from 'components/ui/ErrorAlert';
import DocumentField from './DocumentField';
import { ACCEPTED_FILE_TYPES } from 'config/accepted-file-types';
import { withTranslation } from 'react-i18next';
import { getFilesWithContentType } from 'utils/files/files';
const maxSize = 2000000;
class Documents extends Component {
    constructor(props) {
        super(props);
        this.handleAcceptDrop = (files) => {
            const filesWithContentType = getFilesWithContentType(files);
            this.props.onDrop(filesWithContentType);
        };
        this.handleRejectDrop = (files) => {
            this.setState({
                rejectedFiles: files.map((f) => f.name),
            }, () => {
                setTimeout(() => {
                    this.setState({ rejectedFiles: [] });
                }, 4000);
            });
        };
        this.handleRemove = (i) => () => this.props.onRemove(i);
        this.handleTypeChange = (i) => (type) => this.props.onTypeChange(i, type);
        this.handleCustomValueChange = (i) => (value) => this.props.onCustomValueChange(i, value);
        this.state = {
            rejectedFiles: [],
        };
    }
    renderErrors() {
        if (!this.state.rejectedFiles || this.state.rejectedFiles.length === 0) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement(ErrorAlert, { title: t('MAX_FILE_SIZE_EXCEED') },
            React.createElement("ul", null, this.state.rejectedFiles.map((name) => (React.createElement("li", null, name))))));
    }
    renderDropzone() {
        const className = classnames('flex', 'justify-center', 'items-center', 'w-full', 'h-full', 'border', 'block', 'border-dashed', 'p-4');
        const { t } = this.props;
        return (React.createElement("fieldset", { className: "" },
            React.createElement("div", { className: "block mb-4" },
                React.createElement(Dropzone, { accept: ACCEPTED_FILE_TYPES, className: className, onDropAccepted: this.handleAcceptDrop, onDropRejected: this.handleRejectDrop, maxSize: maxSize },
                    this.props.uploadPending && (React.createElement("div", { className: "flex items-center" },
                        React.createElement("i", { className: "fa fa-spinner fa-spin" }),
                        React.createElement("span", null,
                            t('UPLOADING'),
                            "..."))),
                    !this.props.uploadPending && (React.createElement("p", { className: "block text-grey-darker" }, t('DROP_DOCUMENT_TO_ADD'))))),
            this.renderErrors()));
    }
    renderDocuments() {
        if (!this.props.documents || this.props.documents.length === 0) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement("div", { className: "documents w-full mb-4 md:mb-0 p-4 bg-grey-lightest" },
            React.createElement("label", { className: "mb-2 block form-label" }, t('ATTACHED_DOCUMENTS')),
            this.props.documents.map((doc, i) => (React.createElement(DocumentField, { key: i, doc: doc, onRemove: this.handleRemove(i), onTypeChange: this.handleTypeChange(i), onCustomValueChange: this.handleCustomValueChange(i) })))));
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: "documents-form" },
            React.createElement("h4", { className: "text-grey-dark mb-4" }, t('ATTACH_DOCUMENTS')),
            this.renderDropzone(),
            this.renderDocuments()));
    }
}
Documents.propTypes = {
    uploadPending: PropTypes.bool,
    documents: PropTypes.array,
    onCustomValueChange: PropTypes.func.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onDrop: PropTypes.func.isRequired,
};
Documents.defaultProps = {
    uploadPending: false,
    documents: [],
};
export default withTranslation()(Documents);
